import { useCallback, useState, useMemo, useEffect } from 'react';
import { openSideNav } from '../../func';
import {
  Link,
  useHistory,
  useRouteMatch,
} from 'react-router-dom/cjs/react-router-dom.min';
import { IconButton } from '../../layout/form';
import { useDispatch } from 'react-redux';
import { logOut, registerRoutes } from '../../func';
import Axios from 'axios';

const BuyingGroupOverview = () => {
  const history = useHistory();
  const { path } = useRouteMatch();
  const dispatch = useDispatch();
  const authData = useMemo(
    () => JSON.parse(localStorage.getItem('auth_data')),
    []
  );

  const initState = () => ({
    name: '',
  });

  const [values, setValues] = useState(initState());
  const [buyingGroupList, setBuyingGroupList] = useState([]);

  const networkCalls = useMemo(
    () =>
      registerRoutes(
        {
          search: {
            func: filters => {
              Axios.get('/api/v2/buyinggroup/read/many/search', {
                params: {
                  ...authData,
                  ...filters,
                },
              })
                .then(result => setBuyingGroupList(result.data))
                .catch(logOut);
            },
            type: 'r',
          },
        },
        path
      ),
    [path, dispatch, authData]
  );

  const onChange = ({ target: { value, id } }) =>
    setValues(prev => ({ ...prev, [id]: value }));

  const search = useCallback(
    event => {
      event?.preventDefault();
      networkCalls.search(values);
    },
    [values, networkCalls]
  );

  useEffect(() => {
    search();
  }, []);

  return (
    <div className="main">
      <div className="row">
        <div style={{ display: 'flex' }}>
          <Link to="/" onClick={openSideNav} style={{ marginRight: '12px' }}>
            <i className="material-icons black-text">menu</i>
          </Link>
          <Link to="/">Home</Link>
          <i className="material-icons">chevron_right</i>
          <span className="grey-text">Buying Groups</span>
        </div>
      </div>
      <div className="row">
        <div className="right">
          <IconButton
            icon="add"
            onClick={() => history.push('/buyinggroup/create')}
          />
        </div>
      </div>
      <div className="row">
        <form>
          <div className="row">
            <div className="input-field col s12 m6">
              <input
                id="name"
                type="text"
                onChange={onChange}
                value={values.name}
              />
              <label htmlFor="name">Buying Group Name</label>
            </div>
            <div className="input-field col s12 m2">
              <button
                type="submit"
                className="btn-small blue white-text waves-effect waves-light col s12"
                onClick={search}
              >
                Search
              </button>
            </div>
          </div>
        </form>
      </div>
      <div className="row">
        <table>
          <thead>
            <tr>
              <th>Name</th>
              <th style={{ padding: '4px' }}>City, State</th>
              <th style={{ padding: '4px' }}>Phone</th>
              <th style={{ padding: '4px' }}>Email</th>
              <th style={{ padding: '4px' }}>Website</th>
            </tr>
          </thead>
          <tbody>
            {buyingGroupList?.map(
              ({ id, name, city, state, phone, email, website }) => (
                <tr key={id}>
                  <td style={{ padding: '4px' }}>
                    <Link to={`/buyinggroup/${id}`}>{name}</Link>
                  </td>
                  <td style={{ padding: '4px' }}>
                    {city || ''} {city && state ? ',' : ''} {state?.code || ''}
                  </td>
                  <td style={{ padding: '4px' }}>{phone || ''}</td>
                  <td style={{ padding: '4px' }}>{email || ''}</td>
                  <td style={{ padding: '4px' }}>
                    {website ? (
                      <a href={`https://${website}`} target="blank">
                        website
                      </a>
                    ) : null}
                  </td>
                </tr>
              )
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default BuyingGroupOverview;
